module.exports = __webpack_public_path__ + "static/media/thumb.63428a87.jpg";